import {
  AfterContentChecked,
  Directive,
  ElementRef,
  HostListener,
  Renderer2
} from '@angular/core'
import { StringUtil } from '../utils/string-util'
import { MbConstants } from '../mb-constants'

@Directive({
  selector: '[mbFloatingLabel]',
})
export class MbFloatingLabelDirective implements AfterContentChecked {

  isFocusEvent: boolean = false

  constructor (private render: Renderer2,
               private el: ElementRef) { }

  ngAfterContentChecked () {
    if (!this.isFocusEvent) {
      this.el.nativeElement?.childNodes?.forEach((node: any) => {
        if (node?.nodeName === MbConstants.INPUT
          || node?.nodeName === MbConstants.TEXTAREA
          || (node?.nodeName === MbConstants.BUTTON && node?.hasAttribute(MbConstants.NG_DROPDOWN_TOGGLE))) {
          this.onFocusOut()
        }
      })
      this.isFocusEvent = false
    }
  }

  @HostListener('click')
  private onClick () {
    if (StringUtil.isEmpty(this.fetchInputValue(this.el.nativeElement))) {
      this.render.addClass(this.el.nativeElement, 'focused')
      this.isFocusEvent = true
    }
  }

  @HostListener('focusout')
  private onFocusOut () {
    if (StringUtil.isEmpty(this.fetchInputValue(this.el.nativeElement))) {
      this.render.removeClass(this.el.nativeElement, 'focused')
    } else {
      this.render.addClass(this.el.nativeElement, 'focused')
    }
    this.isFocusEvent = false
  }

  @HostListener('focusin')
  private onFocusIn () {
    this.render.addClass(this.el.nativeElement, 'focused')
    this.isFocusEvent = true
  }

  fetchInputValue (currentNativeElement: any): string {
    if (currentNativeElement === null || currentNativeElement === undefined) {
      return ''
    }

    let value: string = ''

    currentNativeElement.childNodes.forEach((node: any) => {
      if (node?.nodeName === MbConstants.INPUT || node?.nodeName === MbConstants.TEXTAREA) {
        value = node?.value
      } else if (node?.nodeName === MbConstants.BUTTON && node?.hasAttribute(MbConstants.NG_DROPDOWN_TOGGLE)) {
        value = node?.textContent
      }
    })

    return value
  }

  callFocusOutHandler () {
    this.onFocusOut()
  }
}
